import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useMasterDataBatch } from '../../utils/useMasterData';

function AddVehicle({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState({
    VehicleType: '',
    Manufacturer: '',
    ModelName: '',
    Variant: '',
    Segment: '',
    Color: '',
    FuelType: '',
    EngineCC: '',
    LaunchDate: '',
    DiscontinueDate: '',
    Status: 'Active',
    Remarks: ''
  });

  const [launchDate, setLaunchDate] = useState(null);
  const [discontinueDate, setDiscontinueDate] = useState(null);

  // Fetch master data for dropdowns
  const { dataMap: masterData } = useMasterDataBatch([
    'vehicleType',
    'fuelType',
    'engineCC',
    'segment',
    'variant',
    'model',
    'color'
  ]);

  const vehicleTypeOptions = masterData?.vehicleType || [];
  const fuelTypeOptions = masterData?.fuelType || [];
  const engineCCOptions = masterData?.engineCC || [];
  const segmentOptions = masterData?.segment || [];
  const variantOptions = masterData?.variant || [];
  const modelOptions = masterData?.model || [];
  const colorOptions = masterData?.color || [];

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    const updatedData = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedData);
    sendDataToParent(updatedData);
  }

  function handleSelectChange(name, selectedOption) {
    const updatedData = {
      ...formData,
      [name]: selectedOption ? selectedOption.label : ''
    };
    setFormData(updatedData);
    sendDataToParent(updatedData);
  }

  function handleDateChange(name, date) {
    if (name === 'LaunchDate') {
      setLaunchDate(date);
    } else if (name === 'DiscontinueDate') {
      setDiscontinueDate(date);
    }
    const updatedData = {
      ...formData,
      [name]: date || null
    };
    setFormData(updatedData);
    sendDataToParent(updatedData);
  }

  const hasInitialized = useRef(false);
  useEffect(() => {
    if (!hasInitialized.current) {
      onLoad(formData);
      hasInitialized.current = true;
    }
  }, [formData, onLoad]);

  const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Discontinued', label: 'Discontinued' }
  ];

  return (
    <>


      <div className="row">


        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Vehicle Type<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="VehicleType"
              options={vehicleTypeOptions}
              onChange={(option) => handleSelectChange('VehicleType', option)}
              isClearable
              placeholder="Select Vehicle Type"
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Manufacturer<span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="Manufacturer"
              value={formData.Manufacturer}
              onChange={handleChange}
              placeholder="Enter manufacturer name"
            />
          </div>
        </div>

        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Model<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="Model"
              options={modelOptions}
              onChange={(option) => handleSelectChange('ModelName', option)}
              isClearable
              placeholder="Select Model"
            />
          </div>
        </div>

   

        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Variant<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="Variant"
              options={variantOptions}
              onChange={(option) => handleSelectChange('Variant', option)}
              isClearable
              placeholder="Select Variant"
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Segment<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="Segment"
              options={segmentOptions}
              onChange={(option) => handleSelectChange('Segment', option)}
              isClearable
              placeholder="Select Segment"
            />
          </div>
        </div>


  

        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Color<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="Color"
              options={colorOptions}
              onChange={(option) => handleSelectChange('Color', option)}
              isClearable
              placeholder="Select Color"
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Fuel Type<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="FuelType"
              options={fuelTypeOptions}
              onChange={(option) => handleSelectChange('FuelType', option)}
              isClearable
              placeholder="Select Fuel Type"
            />
          </div>
        </div>


        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">
              Engine CC<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="EngineCC"
              options={engineCCOptions}
              onChange={(option) => handleSelectChange('EngineCC', option)}
              isClearable
              placeholder="Select Engine CC"
            />
          </div>
        </div>
        

   

        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">Launch Date</label>
            <DatePicker
              className="form-control"
              selected={launchDate}
              onChange={(date) => handleDateChange('LaunchDate', date)}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select launch date"
              isClearable
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">Discontinue Date</label>
            <DatePicker
              className="form-control"
              selected={discontinueDate}
              onChange={(date) => handleDateChange('DiscontinueDate', date)}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select discontinue date"
              isClearable
            />
          </div>
        </div>

     <div className="col-lg-6">
          <div className="mb-3">
            <label className="form-label">Status<span style={{ color: "red" }}>*</span></label>
            <Select
              name="Status"
              options={statusOptions}
              onChange={(option) => handleSelectChange('Status', option)}
              value={statusOptions.find(opt => opt.value === formData.Status)}
              isClearable
              placeholder="Select Status"
            />
          </div>
        </div>

        <div className="col-lg-12">
          <div className="mb-3">
            <label className="form-label">Remarks</label>
            <textarea
              className="form-control"
              name="Remarks"
              rows="2"
              value={formData.Remarks}
              onChange={handleChange}
              placeholder="Enter remarks"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default AddVehicle
